import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	heading: {
		id: 'navigation-shortcuts.add-repository-modal.heading',
		defaultMessage: 'Connect a repository',
		description: '',
	},
	description: {
		id: 'navigation-shortcuts.add-repository-modal.description',
		defaultMessage:
			'Linking a repository will show information about your branches, commits and pull requests in Jira issues.',
		description: '',
	},
	submitCaption: {
		id: 'navigation-shortcuts.add-repository-modal.submit-caption',
		defaultMessage: 'Connect',
		description: '',
	},
	cancelCaption: {
		id: 'navigation-shortcuts.add-repository-modal.cancel-caption',
		defaultMessage: 'Cancel',
		description: '',
	},
	descriptionIssueTermRefresh: {
		id: 'navigation-shortcuts.add-repository-modal.description-issue-term-refresh',
		defaultMessage:
			'Linking a repository will show information about your branches, commits and pull requests in Jira work items.',
		description: '',
	},
});
